import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { GET_URL_BY_ID } from '@utils/api/endpoints.ts';
import { UserRole } from '@utils/types/users/roles.ts';

export interface UserBo {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  roles: UserRole[];
  is_active: boolean;
}

export interface UserResponse {
  count: number;
  total_results: number;
  result: UserBo;
}

export const useGetUser = (userId: number) => {
  const fetchCustomerUsage = async () => {
    const response = await Axios.get<UserResponse>(
      `${GET_URL_BY_ID(userId.toString()).user}`
    );
    return response.data;
  };

  return useQuery<UserResponse, AxiosError<BaseError>>(
    ['user', userId],
    fetchCustomerUsage,
    {
      useErrorBoundary: false
    }
  );
};
